import { Badge, Button, Divider, Drawer, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import Iconify from "../iconify";
import Scrollbar from "../scrollbar";

type Props = {
    canReset: boolean;
    open: boolean;
    onClose: VoidFunction;
    onOpen: VoidFunction;
    resetFilters: VoidFunction;
    children: JSX.Element;
    width?: number;
}

const DrawerFiltersComponent = ({ canReset, open, onClose, onOpen, resetFilters, children, width }: Props) => {

    return (
        <>
            <Button
                disableRipple
                color="inherit"
                endIcon={
                    <Badge color="error" variant="dot" invisible={!canReset}>
                        <Iconify icon={'ic:round-filter-list'} />
                    </Badge>
                }
                onClick={onOpen}
            >
                Filtros
            </Button>

            <Drawer
                anchor="right"
                open={open}
                onClose={onClose}
                slotProps={{
                    backdrop: { invisible: true }
                }}
                PaperProps={{
                    sx: { width: { xs: 280, md: width ?? 280 } },
                }}
            >
                <Stack
                    direction={'row'}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    sx={{ py: 2, pr: 1, pl: 2.5 }}
                >
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>Filtros</Typography>
                    <Tooltip title="Limpar Filtros">
                        <IconButton onClick={resetFilters}>
                            <Badge color="error" variant="dot" invisible={!canReset}>
                                <Iconify icon={'solar:restart-bold'} />
                            </Badge>
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Fechar">
                        <IconButton onClick={onClose}>
                            <Iconify icon={'mingcute:close-line'} />
                        </IconButton>
                    </Tooltip>
                </Stack>

                <Divider />

                <Scrollbar sx={{ px: 2.5, py: 3 }}>
                    <Stack spacing={3}>
                        {children}
                    </Stack>
                </Scrollbar>
            </Drawer>
        </>
    );

}

export default DrawerFiltersComponent;